import { DataProvider } from 'react-admin';
import { usersProxy } from './apiGateway';

type RegisteredUser = {
    id: string;
    phone: string;
    nickname: string;
    username?: string | null;
    email?: string | null;
    avatarUrl?: string | null;
    avatarId?: string | null;
    bio?: string | null;
    gender: 'MALE' | 'FEMALE' | 'UNKNOWN';
    birthday?: string | null;
    creationDate: string;
    lastUpdateDate: string;
    startDeletionDate?: string | null;
    lastOnlineDate: string;
    isBlocked: boolean;
};

export const usersDataProvider: DataProvider = {
    getList: async () => {
        return Promise.resolve({
            data: [],
            total: 0,
        });
    },

    getOne: async (resource, params) => {
        const { id } = params;

        try {
            const user = await usersProxy.search({ id: String(id) });
            if (!user?.id) {
                throw new Error('User not found');
            }

            const data: RegisteredUser = {
                ...user,
                id: user.id ?? String(id),
            };

            return { data: data as any };
        } catch (error) {
            console.error('Error fetching user:', error);
            throw error;
        }
    },

    getMany: () => Promise.reject('Not implemented'),
    getManyReference: () => Promise.reject('Not implemented'),
    create: () => Promise.reject('Not implemented'),
    update: () => Promise.reject('Not implemented'),
    updateMany: () => Promise.reject('Not implemented'),
    delete: () => Promise.reject('Not implemented'),
    deleteMany: () => Promise.reject('Not implemented'),
};
